module.exports = __webpack_public_path__ + "media/images/credits_logo_2x_large-dfa795b2d1753953409ea765f1da023ef73087678c14df991689141d2426b66d.png";